import axios from 'axios'
import streamSaver from 'streamsaver';
// import app from '@/model/app.js'
let app = null

const imgDomain = process.env.NODE_ENV === "production" ? 'https://mogine.oss-cn-shanghai.aliyuncs.com/' :
	'https://mogine.oss-cn-shanghai.aliyuncs.com/'

let token
console.log(process.env.NODE_ENV)
// 创建 axios 实例
const service = axios.create({
	// baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url '/'
	baseURL: process.env.NODE_ENV === "production" ? '/mogine/api' : '/'
	// timeout: 6000 // 请求超时时间
})
console.log(process.env.NODE_ENV)
// response interceptor
service.interceptors.response.use((response, config) => {
	console.log(response)
	if (response.data) {
		const status = response.data.code || 200
		const message = response.data.msg || '未知错误';
		if (response.data.code === 401) {
			// todo token 失效 退出登录 刷新页面
			// if(token) {
			// store.dispatch('Logout', '请求成功 token 过期 登出').then(() => {
			//   window.location.reload()
			// })
			// }
			console.log(`request code is not 200, code ${status}, error msg ${response.data.msg}`)
			app.user.logout()
			token = null
			return Promise.reject(new Error(message))
		} else if (status != 200) {
			console.log(`request code is not 200, code ${status}, error msg ${response.data.msg}`)
			// notification.error({
			//   message: '提示',
			//   description: response.data.msg
			// })
			return Promise.reject(new Error(message))
		} else {
			// console.log('request response end access token is', !!Vue.ls.get(ACCESS_TOKEN))
			return response.data
		}
	} else {
		return response
	}

})

// request interceptor
service.interceptors.request.use(config => {
	if (token) {
		config.headers['Blade-Auth'] = `bearer ${token}` // 让每个请求携带自定义 token 请根据实际情况自行修改
	}
	config.headers['Authorization'] = 'Basic YXBpOmFwaV9zZWNyZXQ='
	config.headers['X-Requested-With'] = 'XMLHttpRequest'
	return config
})

function updateToken(newToken) {
	token = newToken
}

const $ajax = function(params) {
	return new Promise((resolve, reject) => {
		if (!params.headers) {
			params.headers = []
		}
		if (token) {
			params.headers['Blade-Auth'] = `bearer ${token}` // 让每个请求携带自定义 token 请根据实际情况自行修改
		}
		params.headers['Authorization'] = 'Basic YXBpOmFwaV9zZWNyZXQ='
		params.success = function(res) {
			resolve(res)
		}
		params.error = function(err) {
			reject(err)
		}
		$.ajax(params)
	})

}

const $xhr = function({ url, methods, responseType }) {
	return new Promise((resolve, reject) => {
		var request = new XMLHttpRequest();
		request.open(methods, url, true);
		if (token) {
			request.setRequestHeader('Blade-Auth', `bearer ${token}`) // 让每个请求携带自定义 token 请根据实际情况自行修改
		}
		request.setRequestHeader('Authorization', 'Basic YXBpOmFwaV9zZWNyZXQ=')
		if (responseType) request.responseType = responseType;
		request.onload = function() {
			resolve(request.response)
		};
		request.send();
	})
}

const getResPonseSize = (url) => {
	return new Promise((resolve, reject) => {
		var xhr = new XMLHttpRequest();
		xhr.open('HEAD', url, true);
		xhr.onreadystatechange = function() {
			if (xhr.readyState == 4) {
				if (xhr.status == 200) {
					resolve(xhr.getResponseHeader('Content-Length'))
					// alert('Size in bytes: ' + xhr.getResponseHeader('Content-Length'));     
				} else {
					// alert('ERROR');
					reject('get ResPonse Size error')
				}
			}
		};
		xhr.send(null);
	})
}


async function downloadLargeFile(name, url, onProgress) {
	try {
		
		let res = await service(url)
		let aliUrl = res.data
		console.log(res.data)
		let response = await fetch(aliUrl, {
			method: 'GET'
		})
		// 2. 在GET请求后获取文件大小
		const contentLength = response.headers.get('Content-Length');
		const fileSize = contentLength ? parseInt(contentLength, 10) : 0;

		// 显示文件大小
		// totalSize.textContent = fileSize ? formatFileSize(fileSize) : '未知';

		// 3. 创建可写流
		const fileStream = fileSize ?
			streamSaver.createWriteStream(name, {
				size: fileSize
			}) :
			streamSaver.createWriteStream(name);

		const writer = fileStream.getWriter();
		const reader = response.body.getReader();

		let receivedLength = 0;
		let startTime = Date.now();
		let lastUpdate = Date.now();
		let lastReceived = 0;

		// 缓冲队列（用于在获取文件大小前接收的数据）
		const bufferQueue = [];
		let speed = 0;
		// 4. 流式写入文件
		const processDownload = async () => {
			while (true) {
				const { done, value } = await reader.read();
				if (done) {
					for (const chunk of bufferQueue) {
						await writer.write(chunk);
					}
					await writer.close();
					return;
				}
				receivedLength += value.length;
				const now = Date.now();
				// 计算下载速度（每秒）
				if (now - lastUpdate > 500) {
					const deltaTime = (now - lastUpdate) / 1000;
					const deltaReceived = receivedLength - lastReceived;
					speed = deltaReceived / deltaTime;

					lastUpdate = now;
					lastReceived = receivedLength;
				}
				
				// // 更新下载大小显示
				// downloadedSize.textContent = formatFileSize(receivedLength);

				// // 更新进度条（如果有文件大小）
				// if (fileSize > 0) {
				const percent = Math.round((receivedLength / fileSize) * 100);
				// 	progressFill.style.width = `${percent}%`;
				// 	progressText.textContent = `${percent}%`;
				// } else {
				// 	// 如果没有文件大小，使用动态进度
				// 	const dynamicPercent = Math.min(95, Math.round(receivedLength / 1024 / 1024));
				// 	progressFill.style.width = `${dynamicPercent}%`;
				// 	progressText.textContent = `${dynamicPercent}%`;
				// }
				onProgress&&onProgress(percent, formatFileSize(receivedLength), formatFileSize(fileSize), formatFileSize(speed))

				// 如果文件大小未知，缓冲数据直到我们开始写入
				if (!fileSize && bufferQueue.length < 10) {
					bufferQueue.push(value);
				} else {
					// 写入缓冲数据
					while (bufferQueue.length > 0) {
						await writer.write(bufferQueue.shift());
					}
					// 写入当前数据
					await writer.write(value);
				}
			}
		};

		await processDownload().catch(err => {
			console.error('下载出错:', err);
		});


	} catch (error) {
		console.error('下载出错:', error);
	}
}

// 获取文件信息（大小）
async function getFileInfo(url) {
	try {
		const response1 = await fetch(url, {
			method: 'HEAD',
			redirect: 'manual',
			headers: getAuthHeaders()
		});

		if (!response1.ok) {
			// 	throw new Error(`HEAD请求失败: ${response1.status}`);
			console.log(`HEAD请求失败: ${response1.status}`)
		}

		let response
		console.log(response1.headers.get('Location') || response1.headers.get('location'))
		if (response1.status === 302) {

			const redirectUrl = response1.headers.get('Location');
			response = await fetch(redirectUrl, {
				method: 'HEAD',
				headers: getAuthHeaders(),
				credentials: 'include'
			});
		}

		const contentLength = parseInt(response.headers.get('Content-Length'), 10);

		return {
			contentLength: contentLength,
			contentType: response.headers.get('Content-Type'),
			contentDisposition: response.headers.get('Content-Disposition')
		};
	} catch (error) {
		console.error('获取文件信息失败:', error);
		return {};
	}
}

function getAuthHeaders() {
	let headers = {}
	if (token) {
		headers['Blade-Auth'] = `bearer ${token}` // 让每个请求携带自定义 token 请根据实际情况自行修改
	}
	headers['Authorization'] = 'Basic YXBpOmFwaV9zZWNyZXQ='
	headers['X-Requested-With'] = 'XMLHttpRequest'
	return headers
}


// 辅助函数：格式化文件大小
function formatFileSize(bytes) {
	if (bytes === 0) return '0 Bytes';
	const k = 1024;
	const sizes = ['Bytes', 'KB', 'MB', 'GB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

function setApp(app) {
	app = app
}

export {
	service as axios,
	updateToken,
	imgDomain,
	axios as service,
	$ajax,
	$xhr,
	getResPonseSize,
	downloadLargeFile,
	setApp
}